import { validateEmail } from 'utils/validations/validateEmail';
import { validateStringField } from 'utils/validations/validateStringField';

const signUpOrganizationValidation = (data) => {
  const { title, name, email, password, requires_password } = data;

  validateStringField(title, 'the club name');
  validateStringField(name, 'your name');
  validateEmail(email, 'email');

  if (requires_password) {
    validateStringField(password, 'your password');
  }
};

export default signUpOrganizationValidation;
